import { RIVER_ENABLED } from './features'

// Shared by the device-type selects in Devices, DeviceSettings and DeviceConfigModal —
// these three were identical copies, so a new type only has to be added here.
export const DEVICE_TYPE_OPTIONS = [
  { value: '', text: 'Select device type...' },
  { value: 'well', text: 'Well' },
  { value: 'flume', text: 'Flume' },
  { value: 'plunge', text: 'Plunge Pool' },
  { value: 'bubbler', text: 'Bubbler' }
].concat(
  RIVER_ENABLED ? [{ value: 'river', text: 'River' }] : []
).concat([
  { value: 'rain', text: 'Rain Gauge' }
])

export const DEVICE_METRICS = {
  plunge: [
    { value: 'ec',      text: 'Conductivity',        type: 'float' },
    { value: 'tds',     text: 'TDS',                 type: 'float' },
    { value: 'probe_c', text: 'Probe Temp. (°C)',     type: 'float' },
    { value: 'probe_f', text: 'Probe Temp. (°F)',     type: 'float' },
    { value: 'depth_f', text: 'Pool Depth (ft)',      type: 'float' },
    { value: 'tmp_f',   text: 'Case Temp. (°F)',      type: 'float' },
    { value: 'bat_chg', text: 'Battery (%)',          type: 'float' },
    { value: 'bat_v',   text: 'Battery Voltage (V)',  type: 'float' },
    { value: 'in_v',    text: 'Solar Voltage (V)',    type: 'float' },
    { value: 'in_c',    text: 'Solar Current (A)',    type: 'float' },
    { value: 'cell_sig', text: 'Cell Signal',         type: 'float' }
  ],
  flume: [
    { value: 'flow_cfs', text: 'Flow (CFS)',          type: 'float' },
    { value: 'flow_gpm', text: 'Flow (GPM)',          type: 'float' },
    { value: 'depth_f',  text: 'Depth (ft)',          type: 'float' },
    { value: 'tmp_f',    text: 'Case Temp. (°F)',     type: 'float' },
    { value: 'bat_chg',  text: 'Battery (%)',         type: 'float' },
    { value: 'bat_v',    text: 'Battery Voltage (V)', type: 'float' },
    { value: 'in_v',     text: 'Solar Voltage (V)',   type: 'float' },
    { value: 'in_c',     text: 'Solar Current (A)',   type: 'float' },
    { value: 'cell_sig', text: 'Cell Signal',         type: 'float' }
  ],
  well: [
    { value: 'depth_f',  text: 'Depth to Water (ft)', type: 'float' },
    { value: 'pres_hpa', text: 'Pressure (hPa)',      type: 'float' },
    { value: 'tmp_f',    text: 'Case Temp. (°F)',     type: 'float' },
    { value: 'bat_chg',  text: 'Battery (%)',         type: 'float' },
    { value: 'bat_v',    text: 'Battery Voltage (V)', type: 'float' },
    { value: 'in_v',     text: 'Solar Voltage (V)',   type: 'float' },
    { value: 'in_c',     text: 'Solar Current (A)',   type: 'float' },
    { value: 'cell_sig', text: 'Cell Signal',         type: 'float' }
  ],
  river: [
    { value: 'depth_f',    text: 'River Stage (ft)',     type: 'float' },
    { value: 'pres_hpa',   text: 'Pressure (hPa)',       type: 'float' },
    { value: 'tmp_f',      text: 'Case Temp. (°F)',      type: 'float' },
    { value: 'bat_chg',    text: 'Battery (%)',          type: 'float' },
    { value: 'bat_v',      text: 'Battery Voltage (V)',  type: 'float' },
    { value: 'in_v',       text: 'Solar Voltage (V)',    type: 'float' },
    { value: 'in_c',       text: 'Solar Current (A)',    type: 'float' },
    { value: 'cell_sig',   text: 'Cell Signal',          type: 'float' }
  ],
  bubbler: [
    { value: 'cf_depth_f', text: 'Water Elevation (ft)', type: 'float' },
    { value: 'pres_hpa',   text: 'Pressure (hPa)',       type: 'float' },
    { value: 'tmp_f',      text: 'Case Temp. (°F)',      type: 'float' },
    { value: 'bat_chg',    text: 'Battery (%)',          type: 'float' },
    { value: 'bat_v',      text: 'Battery Voltage (V)',  type: 'float' },
    { value: 'in_v',       text: 'Solar Voltage (V)',    type: 'float' },
    { value: 'in_c',       text: 'Solar Current (A)',    type: 'float' },
    { value: 'cell_sig',   text: 'Cell Signal',          type: 'float' }
  ]
}

export const REMINDER_INTERVALS = {
  0: 'Never',
  3600: 'Hourly',
  21600: 'Every 6 Hours',
  43200: 'Every 12 Hours',
  86400: 'Daily'
}

export const EXPIRE_INTERVALS = {
  0: 'Never',
  86400: '1 Day',
  259200: '3 Days',
  604800: '1 Week'
}

export const ELEVATION_SURVEYS = {
  'P-3-92': 327.16,
  'PTW-3': 288.95,
  'MW-05S': 620.51,
  'MW-64': 641.93,
  'MW-09': 404.96,
  'MW-108': 419.88,
  'MW-06': 1538.02,
  'LMW-5': 209.82
}

export const FLUME_THRESHOLDS = {
  'kingfield-flume': [
    // each of these is for a month, starting january.. these are in gpm, this is minimum value. alert threshold is  20% higher than min
    210, 195, 215, 725, 600, 205, 90, 55, 70, 125, 320, 280
  ],
  'hollis-flume-2': [
    781, 781, 1028, 1746, 1145, 845, 812, 723, 723, 781, 960, 812
  ]
}

export const DATE_SHORTCUTS = [
  {
    text: 'Last Day',
    start: new Date(Date.now() - 3600 * 1000 * 24 * 1),
    end: new Date()
  },
  {
    text: 'Last Week',
    start: new Date(Date.now() - 3600 * 1000 * 24 * 7),
    end: new Date()
  },
  {
    text: 'Last Month',
    start: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    end: new Date()
  },
  {
    text: 'Last 3 Months',
    start: new Date(new Date().setMonth(new Date().getMonth() - 3)),
    end: new Date()
  },
  {
    text: 'Last Year',
    start: new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
    end: new Date()
  },
  {
    text: 'Last 3 Years',
    start: new Date(new Date().setFullYear(new Date().getFullYear() - 3)),
    end: new Date()
  },
  {
    text: 'Last 7 Years',
    start: new Date(new Date().setFullYear(new Date().getFullYear() - 7)),
    end: new Date()
  },
  {
    text: 'Last 10 Years',
    start: new Date(new Date().setFullYear(new Date().getFullYear() - 10)),
    end: new Date()
  }
]